import { ColorModeScript } from '@chakra-ui/react';
import { store } from 'store';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { tr, en, ru } from 'make-plural/plurals';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'moment/locale/tr';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'moment/locale/ru';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'moment/locale/en-gb';
import { messages as trMessages } from './locales/tr/messages';
import { messages as enMessages } from './locales/en/messages';
import { messages as ruMessages } from './locales/ru/messages';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// Set default moment locale to Turkish
moment.locale('tr');

i18n.loadLocaleData({
  tr: { plurals: tr },
  en: { plurals: en },
  ru: { plurals: ru },
});

i18n.load({
  tr: trMessages,
  en: enMessages,
  ru: ruMessages,
});

// Set default language
i18n.activate('tr');

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ColorModeScript />
          <App />
        </QueryClientProvider>
      </Provider>
    </I18nProvider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
